import React from "react";
import { AnswerContext } from "../../store/answerStore";
import ReactionSummary, { CRSRSum } from "./reactionSummary";

export default function TestSumSRCR({ type }) {
  const { answerC, dispatchAnswer } = AnswerContext();
  let accuracy;
  let reactionTime = 0;
  let correctTap = 0;
  let inCorrectTap = 0;
  let anticipatoryTap = 0;
  let earlyTap = 0;
  let lateTap = 0;
  let fastest = 10000;
  let slowest = 0;
  let lengthOfCorrect = 0;
  let reactionLen = 0;

  answerC.answers.forEach((answer) => {
    if (type === "choice_reaction") {
      if (
        answer.answer.userTapFirst.correct === 1 &&
        answer.answer.userTapSec.correct === 1
      ) {
        lengthOfCorrect = lengthOfCorrect + 1;
        correctTap = correctTap + 1;
      } else {
        inCorrectTap = inCorrectTap + 1;
      }

      if (answer.answer.userTapFirst.timeTaken < 50) {
        anticipatoryTap = anticipatoryTap + 1;
      }
      if (answer.answer.userTapSec.timeTaken < 50) {
        anticipatoryTap = anticipatoryTap + 1;
      }
    }

    // totalTimeTaken = 10000 is false condition of early tap or late tape
    if (type === "simple_reaction") {
      if (answer.answer.totalTimeTaken !== 10000) {
        correctTap = correctTap + 1;
        lengthOfCorrect = lengthOfCorrect + 1;
      } else {
        inCorrectTap = inCorrectTap + 1;
      }
      if (answer.answer.totalTimeTaken < 75) {
        anticipatoryTap = anticipatoryTap + 1;
      }
    }

    if (answer.answer.answer_flag === "Too Early") {
      earlyTap = earlyTap + 1;
    }

    if (answer.answer.answer_flag === "Too Late") {
      lateTap = lateTap + 1;
    }

    // total reaction time
    if (
      answer.answer.totalTimeTaken !== 10000 // 10000 if user doesn't do anything
    ) {
      console.log("reaction sum up condition run");
    } else {
      console.log("reaction sum up condition not run");
    }

    // fastest reaction time
    if (
      answer.answer.totalTimeTaken !== 10000 &&
      answer.answer.totalTimeTaken < fastest
    ) {
      fastest = answer.answer.totalTimeTaken;
    }

    // slowest reaction time
    if (
      answer.answer.totalTimeTaken !== 10000 && // 10000 if user doesn't do anything
      answer.answer.totalTimeTaken > slowest
    ) {
      slowest = answer.answer.totalTimeTaken;
    }

    // for total reaction
    if (answer.answer.totalTimeTaken < 10000) {
      reactionLen = reactionLen + 1;
      reactionTime = reactionTime + answer.answer.totalTimeTaken;
    }
  });

  //avg of total user reaction
  reactionTime = reactionLen ? reactionTime / reactionLen : 0;
  accuracy = (correctTap / answerC.answers.length) * 100;

  return (
    <div className="sum-dnb">
      <CRSRSum
        averageTimeSpend={Math.floor(reactionTime)}
        accuracy={Math.floor(accuracy)}
        reactionTime={reactionTime}
        anticipatoryTap={anticipatoryTap}
        correctTap={correctTap}
        incorrectTap={inCorrectTap}
        earlyTap={earlyTap}
        lateTap={lateTap}
        fastest={fastest}
        slowest={slowest}
      />
    </div>
  );
}
